import { useEffect } from "react"
import { Toaster, type ToasterProps } from "sonner"
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon, Loader2Icon } from "lucide-react"
import { Icon } from "../../../shared/components/Icon"
import { useTheme } from "@/shared/hooks/useTheme"
import { notifyToastContainerReady } from "@/shared/lib/toast"

export const ToastContainer = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme()

  useEffect(() => {
    notifyToastContainerReady()
  }, [])

  return (
    <Toaster
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <Icon icon={CircleCheckIcon} className="" />,
        info: <Icon icon={InfoIcon} className="" />,
        warning: <Icon icon={TriangleAlertIcon} className="" />,
        error: <Icon icon={OctagonXIcon} className="" />,
        loading: <Icon icon={Loader2Icon} className="animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
          "--toast-icon-margin-start": "-5px",
          "--toast-svg-margin-start": "0px",
          "--toast-svg-margin-end": "0px",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "!shadow-md",
          content: "w-full",
          loading: "bg-loading-toast! text-loading-toast-foreground! shadow-none! border-none!",
        },
      }}
      position="top-right"
      expand={true}
      visibleToasts={5}
      richColors={true}
      {...props}
    />
  )
}
